import { ClockIcon, MessageCircleIcon, TriangleAlertIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** « Bon à savoir »: no chatbot, the response time, and who to call in an emergency. */
export default function GoodToKnow() {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-6">
      <p className="text-xs font-bold tracking-widest text-foreground uppercase">{t('messagingV3.goodToKnow.title')}</p>
      <ul className="flex flex-col gap-4 text-sm [&_svg]:mt-0.5 [&_svg]:size-4 [&_svg]:shrink-0">
        <li className="flex gap-2.5 text-muted-foreground">
          <MessageCircleIcon aria-hidden />
          {t('messagingV3.goodToKnow.noChatbot')}
        </li>
        <li className="flex gap-2.5 text-muted-foreground">
          <ClockIcon aria-hidden />
          {t('messagingV3.goodToKnow.responseTime')}
        </li>
        <li className="flex gap-2.5 font-medium text-foreground">
          <TriangleAlertIcon aria-hidden />
          {t('messagingV3.goodToKnow.emergency')}
        </li>
      </ul>
    </section>
  );
}
